import {
  call,
  put,
  select,
  takeEvery,
  takeLatest
} from '@redux-saga/core/effects';
import { AiFillCodeSandboxCircle } from 'react-icons/ai';
import { ActionType } from 'typesafe-actions';

import * as Actions from '../actions/basisGroupAction';
import * as MessageActions from '../../../comn/message/actions/comnMessageAction';
import * as Apis from '../apis/basisGroupApi';
import * as Models from '../models/basisGroupModel';
import { goBack } from 'connected-react-router';
import { useDispatch } from 'react-redux';
import {
  DELETE_MESSAGE,
  ERROR_MESSAGE,
  SAVE_MESSAGE
} from '../../../../configs/constants';

function* listMyGroupSaga(action: ActionType<typeof Actions.MY_LIST.request>) {
  try {
    const params = action.payload;
    const res = yield call(Apis.groupAPI.listMyGroup, params);
    const { data, count, errorCode, errorMessage } = res;
    if (errorCode) {
      // 오류메시지 호출
      yield put(
        MessageActions.IS_ERROR({
          errorCode: errorCode,
          errorMessage: '처리중 오류가 발생하였습니다',
          isHistoryBack: false,
          isRefresh: false
        })
      );

      return;
    }
    yield put(
      Actions.MY_LIST.success({
        data: data,
        count: count
      })
    );
  } catch (error) {
    yield put(Actions.MY_LIST.failure(error));
  }
}

function* listMyJoinSaga(action: ActionType<typeof Actions.JOIN_LIST.request>) {
  try {
    const params = action.payload;

    const res = yield call(Apis.groupAPI.listMyGroupJoin, params);
    const { data, count, errorCode, errorMessage } = res;

    if (errorCode) {
      // 오류메시지 호출
      yield put(
        MessageActions.IS_ERROR({
          errorCode: errorCode,
          errorMessage: '처리중 오류가 발생하였습니다',
          isHistoryBack: false,
          isRefresh: false
        })
      );

      return;
    }

    yield put(
      Actions.JOIN_LIST.success({
        data: data,
        count: count
      })
    );
  } catch (error) {
    yield put(Actions.JOIN_LIST.failure(error));
  }
}
function* GrouplistSaga(
  action: ActionType<typeof Actions.GROUP_MAIN_LIST.request>
) {
  try {
    const params = action.payload;

    const res = yield call(Apis.groupAPI.grouplist, params);
    const { data, count, errorCode, errorMessage } = res;
    if (errorCode) {
      // 오류메시지 호출
      debugger;
      yield put(
        MessageActions.IS_ERROR({
          errorCode: errorCode,
          errorMessage: '처리중 오류가 발생하였습니다',
          isHistoryBack: false,
          isRefresh: false
        })
      );

      return;
    }

    yield put(
      Actions.GROUP_MAIN_LIST.success({
        data: data,
        count: count
      })
    );
  } catch (error) {
    yield put(Actions.GROUP_MAIN_LIST.failure(error));
  }
}
function* myJoinSaga(action: ActionType<typeof Actions.GROUP_MYLIST.request>) {
  try {
    const params = action.payload;

    const res = yield call(Apis.groupAPI.listMyGroupJoin, params);
    const { data, count, errorCode, errorMessage } = res;

    if (errorCode) {
      // 오류메시지 호출
      yield put(
        MessageActions.IS_ERROR({
          errorCode: errorCode,
          errorMessage: '처리중 오류가 발생하였습니다',
          isHistoryBack: false,
          isRefresh: false
        })
      );

      return;
    }

    yield put(
      Actions.GROUP_MYLIST.success({
        data: data,
        count: count
      })
    );
  } catch (error) {
    yield put(Actions.GROUP_MYLIST.failure(error));
  }
}
function* createIdSaga(
  action: ActionType<typeof Actions.GROUP_CREATEID.request>
) {
  try {
    const params = action.payload;

    const { data } = yield call(Apis.groupAPI.createid);

    yield put(Actions.GROUP_CREATEID.success(data.result));
  } catch (error) {
    yield put(Actions.GROUP_CREATEID.failure(error));
  }
}

function* detailGroupSaga(
  action: ActionType<typeof Actions.GROUP_DETAIL.request>
) {
  try {
    const id = action.payload;
    const res = yield call(Apis.groupAPI.detailGroup, id);

    const { data } = res;
    yield put(Actions.GROUP_DETAIL.success(data));
  } catch (error) {
    yield put(Actions.GROUP_DETAIL.failure(error));
  }
}

function* createGroupSaga(
  action: ActionType<typeof Actions.GROUP_CREATE.request>
) {
  try {
    const groupDetail = action.payload;
    const res = yield call(Apis.groupAPI.createGroup, groupDetail);

    const { data } = res;

    if (data.result) {
      yield put(
        MessageActions.IS_MESSAGE({
          messageCode: SAVE_MESSAGE.code,
          message: SAVE_MESSAGE.message,
          isHistoryBack: true,
          isRefresh: false
        })
      );
    } else {
      if (data.errorCode === 'DT002') {
        yield put(
          MessageActions.IS_ERROR({
            errorCode: ERROR_MESSAGE.code,
            errorMessage: data.errorMessage + ' (그룹명)',
            isHistoryBack: false,
            isRefresh: false
          })
        );
      } else {
        throw Error;
      }
    }
  } catch (error) {
    yield put(
      MessageActions.IS_ERROR({
        errorCode: ERROR_MESSAGE.code,
        errorMessage: ERROR_MESSAGE.message,
        isHistoryBack: false,
        isRefresh: false
      })
    );
    // yield put(Actions.GROUP_CREATE.failure(error));
  }
}

function* updateGroupSaga(
  action: ActionType<typeof Actions.GROUP_UPDATE.request>
) {
  try {
    const groupDetail = action.payload;
    const res = yield call(Apis.groupAPI.updateGroup, groupDetail);

    const { data } = res;

    if (data.result) {
      yield put(
        MessageActions.IS_MESSAGE({
          messageCode: SAVE_MESSAGE.code,
          message: SAVE_MESSAGE.message,
          isHistoryBack: true,
          isRefresh: false
        })
      );
    } else {
      // throw Error;
      if (data.errorCode === 'DT002') {
        yield put(
          MessageActions.IS_ERROR({
            errorCode: ERROR_MESSAGE.code,
            errorMessage: data.errorMessage + ' (그룹명)',
            isHistoryBack: false,
            isRefresh: false
          })
        );
      } else {
        throw Error;
      }
    }
  } catch (error) {
    yield put(
      MessageActions.IS_ERROR({
        errorCode: ERROR_MESSAGE.code,
        errorMessage: ERROR_MESSAGE.message,
        isHistoryBack: false,
        isRefresh: false
      })
    );
    // yield put(Actions.GROUP_UPDATE.failure(error));
  }
}

function* deleteGroupSaga(
  action: ActionType<typeof Actions.GROUP_DELETE.request>
) {
  try {
    const groupId = action.payload;
    const res = yield call(Apis.groupAPI.deleteGroup, groupId);

    const { data } = res;

    if (data.result) {
      yield put(
        MessageActions.IS_MESSAGE({
          messageCode: DELETE_MESSAGE.code,
          message: DELETE_MESSAGE.message,
          isHistoryBack: true,
          isRefresh: false
        })
      );
    } else {
      throw Error;
    }
  } catch (error) {
    yield put(
      MessageActions.IS_ERROR({
        errorCode: ERROR_MESSAGE.code,
        errorMessage: ERROR_MESSAGE.message,
        isHistoryBack: false,
        isRefresh: false
      })
    );
    // yield put(Actions.GROUP_DELETE.failure(error));
  }
}

function* listGroupSaga(action: ActionType<typeof Actions.GROUP_LIST.request>) {
  try {
    const id = action.payload;
    const res = yield call(Apis.groupAPI.grouplist, id);
    const { data, count } = res;

    yield put(
      Actions.GROUP_LIST.success({
        data: data,
        count: count
      })
    );
  } catch (error) {
    yield put(Actions.GROUP_LIST.failure(error));
  }
}

function* groupJoinListSaga(
  action: ActionType<typeof Actions.GROUP_JOINLIST.request>
) {
  try {
    const { searchParams } = action.payload;
    const res = yield call(Apis.groupAPI.listGroupJoin, searchParams);
    const { data, count } = res;

    yield put(
      Actions.GROUP_JOINLIST.success({
        data: data,
        count: count
      })
    );
  } catch (error) {
    yield put(Actions.GROUP_JOINLIST.failure(error));
  }
}

function* createJoinGroupSaga(
  action: ActionType<typeof Actions.GROUP_JOIN.request>
) {
  try {
    const groupDetail = action.payload;
    const res = yield call(Apis.groupAPI.createJoinGroup, groupDetail);

    const { data } = res;

    if (data.result) {
      yield put(
        MessageActions.IS_MESSAGE({
          messageCode: SAVE_MESSAGE.code,
          message: SAVE_MESSAGE.message,
          isHistoryBack: true,
          isRefresh: false
        })
      );
    } else {
      throw Error;
    }
  } catch (error) {
    yield put(
      MessageActions.IS_ERROR({
        errorCode: ERROR_MESSAGE.code,
        errorMessage: ERROR_MESSAGE.message,
        isHistoryBack: false,
        isRefresh: false
      })
    );
    // yield put(Actions.GROUP_UPDATE.failure(error));
  }
}

function* updateJoinGroupSaga(
  action: ActionType<typeof Actions.GROUP_JOIN_UPDATE.request>
) {
  try {
    const groupDetail = action.payload;
    const res = yield call(Apis.groupAPI.updateJoinGroup, groupDetail);

    const { data } = res;

    if (data.result) {
      yield put(
        MessageActions.IS_MESSAGE({
          messageCode: SAVE_MESSAGE.code,
          message: SAVE_MESSAGE.message,
          isHistoryBack: false,
          isRefresh: true
        })
      );
    } else {
      throw Error;
    }
  } catch (error) {
    yield put(
      MessageActions.IS_ERROR({
        errorCode: ERROR_MESSAGE.code,
        errorMessage: ERROR_MESSAGE.message,
        isHistoryBack: false,
        isRefresh: false
      })
    );
    // yield put(Actions.GROUP_UPDATE.failure(error));
  }
}

function* aprvListSaga(
  action: ActionType<typeof Actions.APPROVAL_LIST.request>
) {
  try {
    const { searchParams, page } = action.payload;
    const res = yield call(Apis.groupAPI.listGroupAprv, searchParams, page);
    const {
      data: { items, total },
      count
    } = res;

    yield put(
      Actions.APPROVAL_LIST.success({
        data: items,
        count,
        total
      })
    );
  } catch (error) {
    yield put(Actions.APPROVAL_LIST.failure(error));
  }
}

function* updateAprvSaga(
  action: ActionType<typeof Actions.APPROVAL_UPDATE.request>
) {
  try {
    const saveData = action.payload;
    const res = yield call(Apis.groupAPI.updateAprvGroup, saveData);

    const { data } = res;

    if (data.result) {
      yield put(
        MessageActions.IS_MESSAGE({
          messageCode: SAVE_MESSAGE.code,
          message: SAVE_MESSAGE.message,
          isHistoryBack: false,
          isRefresh: true
        })
      );
    } else {
      throw Error;
    }
  } catch (error) {
    yield put(
      MessageActions.IS_ERROR({
        errorCode: ERROR_MESSAGE.code,
        errorMessage: ERROR_MESSAGE.message,
        isHistoryBack: false,
        isRefresh: false
      })
    );
    // yield put(Actions.GROUP_UPDATE.failure(error));
  }
}

//사용자 관리 - 사용자 목록
function* userListSaga(action: ActionType<typeof Actions.USER_LIST.request>) {
  try {
    const { searchParams } = action.payload;
    const res = yield call(Apis.groupAPI.listGroupUser, searchParams);
    // const { data } = res;
    const {
      data: { items, total },
      count
    } = res;
    yield put(
      Actions.USER_LIST.success({
        // data: data.items,
        // count: data.total
        data: items,
        count,
        total
      })
    );
  } catch (error) {
    yield put(Actions.USER_LIST.failure(error));
  }
}

function* updateUserSaga(
  action: ActionType<typeof Actions.USER_UPDATE.request>
) {
  try {
    const saveData = action.payload;
    const res = yield call(Apis.groupAPI.updateUser, saveData);

    const { data } = res;

    if (data.result) {
      yield put(
        MessageActions.IS_MESSAGE({
          messageCode: SAVE_MESSAGE.code,
          message: SAVE_MESSAGE.message,
          isHistoryBack: false,
          isRefresh: true
        })
      );
    } else {
      throw Error;
    }
  } catch (error) {
    yield put(
      MessageActions.IS_ERROR({
        errorCode: ERROR_MESSAGE.code,
        errorMessage: ERROR_MESSAGE.message,
        isHistoryBack: false,
        isRefresh: false
      })
    );
    // yield put(Actions.GROUP_UPDATE.failure(error));
  }
}

function* delegateUserSaga(
  action: ActionType<typeof Actions.USER_DELEGATE.request>
) {
  try {
    const saveData = action.payload;
    const res = yield call(Apis.groupAPI.delegateUser, saveData);

    const { data } = res;

    if (data.result) {
      yield put(
        MessageActions.IS_MESSAGE({
          messageCode: SAVE_MESSAGE.code,
          message: SAVE_MESSAGE.message,
          isHistoryBack: false,
          isRefresh: true
        })
      );
    } else {
      throw Error;
    }
  } catch (error) {
    yield put(
      MessageActions.IS_ERROR({
        errorCode: ERROR_MESSAGE.code,
        errorMessage: ERROR_MESSAGE.message,
        isHistoryBack: false,
        isRefresh: false
      })
    );
    // yield put(Actions.GROUP_UPDATE.failure(error));
  }
}

export function* basGroupSaga() {
  yield takeEvery(Actions.MY_LIST.request, listMyGroupSaga);
  yield takeEvery(Actions.JOIN_LIST.request, listMyJoinSaga);
  yield takeEvery(Actions.GROUP_MYLIST.request, myJoinSaga);
  yield takeEvery(Actions.GROUP_DETAIL.request, detailGroupSaga);
  yield takeEvery(Actions.GROUP_CREATE.request, createGroupSaga);
  yield takeEvery(Actions.GROUP_UPDATE.request, updateGroupSaga);
  yield takeEvery(Actions.GROUP_DELETE.request, deleteGroupSaga);
  yield takeEvery(Actions.GROUP_CREATEID.request, createIdSaga);
  yield takeEvery(Actions.GROUP_LIST.request, listGroupSaga);
  yield takeEvery(Actions.GROUP_JOINLIST.request, groupJoinListSaga);
  yield takeEvery(Actions.APPROVAL_LIST.request, aprvListSaga);
  yield takeEvery(Actions.USER_LIST.request, userListSaga);
  yield takeEvery(Actions.GROUP_JOIN.request, createJoinGroupSaga);
  yield takeEvery(Actions.GROUP_JOIN_UPDATE.request, updateJoinGroupSaga);
  yield takeEvery(Actions.APPROVAL_UPDATE.request, updateAprvSaga);
  yield takeEvery(Actions.USER_UPDATE.request, updateUserSaga);
  yield takeEvery(Actions.USER_DELEGATE.request, delegateUserSaga);
  yield takeEvery(Actions.GROUP_MAIN_LIST.request, GrouplistSaga);
}
